// Listens for "ce:invalidate" events and runs the callback. Use to refresh data
// when something somewhere changes (admin saves pricing, etc.) AND on window focus.
import { useEffect } from "react";

export function useLiveData(callback) {
  useEffect(() => {
    callback();
    const onInvalidate = () => callback();
    const onFocus = () => { if (!document.hidden) callback(); };
    window.addEventListener("ce:invalidate", onInvalidate);
    window.addEventListener("focus", onFocus);
    document.addEventListener("visibilitychange", onFocus);
    return () => {
      window.removeEventListener("ce:invalidate", onInvalidate);
      window.removeEventListener("focus", onFocus);
      document.removeEventListener("visibilitychange", onFocus);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}

export function invalidateAll() {
  window.dispatchEvent(new CustomEvent("ce:invalidate"));
}
